import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import { useGeneralStore } from '@/pinia'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayRoomEdit',
  props: {
    showForEntityTypes: {},
    title: {}
  },
  setup(__props: any) {


const piniaStore = useGeneralStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)

function onClick() {
  piniaStore.setCurrentOverlayModalPinia('editRoomPinia')
  piniaStore.setShowOverlayModalPinia(true)
}

return (_ctx: any,_cache: any) => {
  return (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
    ? (_openBlock(), _createBlock(ButtonText, {
        key: 0,
        buttonText: _ctx.title,
        iconLeft: require('@/design-system/assets/icons/Icon-Edit-Small.svg'),
        class: "edit-button",
        size: "small",
        onOnClicked: onClick
      }, null, 8, ["buttonText", "iconLeft"]))
    : _createCommentVNode("", true)
}
}

})